import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './PrivateMeetingNotAccessible.scss'

export const PrivateMeetingNotAccessible: React.FC = () => {
  return (
    <Container className='d-flex flex-column align-items-center gap-2 align-self-stretch private-container'>
      <Row className='p-0'>
        <div className='text-center mt-5'>
          <i className='bi bi-lock fs-2 zocks-bg-color-gray-200 d-inline-flex text-center align-items-center align-content-center justify-content-center private-icon' />
        </div>
      </Row>
      <Row>
        <Col className='mx-auto'>
          <div className='d-flex flex-column gap-2 justify-content-center align-items-center text-center mt-3'>
            <p className='zocks-text-gray-900 paragraph-large medium text-center mb-0 private-title'>This meeting is private</p>
            <p className='paragraph-small'>
              Only meeting participants can access this private meeting. If you need to view this content, ask the person who shared the link to make the
              meeting public.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
